export function incBaseIdentity(path: string): string {
  const prefix = '/account'
  const startsWithSlash = path.slice(0, 1) === '/'
  if (startsWithSlash || path === '') {
    return `${prefix}${path}`
  } else {
    return `${prefix}/${path}`
  }
}
